// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../../Banner';

export const Content = styled.div`
  padding: 16px 30px;
`;
Content.displayName = 'S.Content';

export const HintTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
`;
HintTitle.displayName = 'S.HintTitle';

export const BannerWithMargin = styled(Banner)`
  margin: 8px 0;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';
